import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IonPage, IonContent, IonSpinner, IonText } from '@ionic/react';
import { useStationDevice } from '../../application/use-cases/weatherStation/useStationDevice';
import StationHome from '../components/station/StationHome';

// El home de una estación abierto desde su lote o desde Sensores, con el
// mismo encabezado que el Inicio y una flecha para volver.
const StationPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { device, error } = useStationDevice(id);
  const back = () => (history.length > 1 ? history.goBack() : history.replace('/app/dashboard'));

  return (
    <IonPage>
      <IonContent fullscreen>
        {!device && !error && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}
        {error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}
        {device && <StationHome key={device.id} station={device} hero={{ alertCount: 0, onBack: back }} showForecast={false} />}
      </IonContent>
    </IonPage>
  );
};

export default StationPage;
